import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = () => {
  const { user, isHydrating } = useContext(AuthContext);

  // ⏳ Wait for hydration check to finish before deciding
  if (isHydrating) {
    return (
      <div className="w-full h-full flex items-center justify-center py-20 text-white/80">
        Checking your session…
      </div>
    );
  }

  // 🚪 No user after hydration → go to sign in
  if (!user) {
    return <Navigate to="/sign-in" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
